module.exports = __webpack_public_path__ + "static/media/coworkers.39f72c48.svg";